import React from 'react';
import PropTypes from 'prop-types';
import {IsNullOrUndefined} from "../../constants";


const TextViewControl = (props) => {
  let {labelText, value, boldLabel, style, visible, col1, col2} = props;

  if (boldLabel === undefined) {
    boldLabel = false;
  }
  col1 = IsNullOrUndefined(col1) ? 4 : col1;
  col2 = IsNullOrUndefined(col2) ? 8 : col2;

  return IsNullOrUndefined(value) || visible === false ? null : (
      <div className="pi-row" style={style}>
        <div className={`pi-col-sm-${col1}`} style={{fontWeight: boldLabel ? 'bold' : ''}}>{labelText}</div>
        <div className={`pi-col-sm-${col2}`}>{value == null ? 'N/A' : value}</div>
      </div>
  );
};

TextViewControl.propTypes = {
  labelText: PropTypes.string.isRequired,
};
export default TextViewControl;